import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/components/atoms/Toast';
import {
	activateDefaultPrompt,
	ActivateDefaultPromptProps
} from '@/services/sandboxPromptsService';
import type { HttpResponseError } from '@/services/service';

type UseActivateDefaultPromptMutationProps = {
	onSuccess: () => void;
};

export const useActivateDefaultPromptMutation = ({
	onSuccess
}: UseActivateDefaultPromptMutationProps) => {
	const { toast } = useToast();
	const queryClient = useQueryClient();

	return useMutation<unknown, HttpResponseError, ActivateDefaultPromptProps>({
		mutationKey: ['sandbox-prompt-activate-default'],
		mutationFn: activateDefaultPrompt,
		onSuccess: () => {
			queryClient.invalidateQueries(['sandbox-prompt-query']);
			onSuccess();
		},
		onError: error => {
			// eslint-disable-next-line no-console
			console.error({ error });

			toast({
				title: 'Failed to activate default prompt. Please try again later.',
				variant: 'error'
			});
		}
	});
};
